module.exports = __webpack_public_path__ + "static/media/pittlogo.b0d414ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/undergrad/pittlogo.png
// module id = 487
// module chunks = 0